import React from 'react';
import Button from '#lib/components/button.jsx';
import { addClasses, cn } from '#lib/helpers/class.js';
import { Icon } from '@iconify-icon/react/dist/iconify.js';
import { PackagesIDs } from '#routes/settings/billing/billing-helpers.js';

export default function PackCard(props) {
    const { pack, onBuy, isLoading, discount, activePack } = props;

    const packageType = pack.id;
    const isUserPack = packageType === PackagesIDs.USER;

    return (
        <div key={pack.id} className="rounded-lg overflow-auto shadow-md p-3 text-center border max-w-[300px] h-full">
            <div className="font-bold text-lg">
                <h2>{pack.id}</h2>
            </div>
            <div className="my-2 relative">
                <p
                    className={cn(
                        'flex justify-center items-center gap-1 transition-all duration-500',
                        isUserPack && 'hidden',
                        discount ? 'opacity-0' : 'opacity-100 delay-300'
                    )}
                >
                    <span className="font-bold text-lg">€{(pack.price / 12).toFixed(2)}</span>
                    <span className="font-semibold text-sm">{_t.global.plusVat()}</span>
                </p>
                <p className={cn('text-xs', isUserPack && 'hidden', discount ? 'opacity-0' : 'opacity-100 delay-300')}>
                    {_t.billing.billedAnnually()}
                </p>
                <p
                    className={cn(
                        'flex justify-center items-center gap-1 italic',
                        isUserPack && 'font-bold text-lg xl:text-xl not-italic',
                        !isUserPack && 'transition-all duration-500 text-sm text-gray-700',
                        discount ? 'opacity-0' : 'opacity-100 delay-300'
                    )}
                >
                    <span>€{pack.price.toFixed(2)}</span>
                    <span>{_t.global.plusVat()}</span>
                    <span>{_t.billing.perYear()}</span>
                </p>
                <div
                    className={cn(
                        'absolute left-0 top-0 w-full h-full flex flex-col justify-center items-center transition-all duration-500',
                        discount ? 'opacity-100 scale-1 delay-200' : 'opacity-0 scale-0'
                    )}
                >
                    <p className={cn('font-bold text-lg xl:text-xl text-primary-500', isUserPack && 'hidden')}>
                        €{((pack.price - pack.price * (discount / 100)) / 12).toFixed(2)}
                    </p>
                    <p className="text-xs">{_t.billing.billedAnnually()}</p>
                    <p
                        className={cn(
                            'italic',
                            isUserPack && 'font-bold text-lg xl:text-xl not-italic',
                            !isUserPack && 'text-sm text-gray-700'
                        )}
                    >
                        €{!isUserPack ? (pack.price - pack.price * (discount / 100)).toFixed(2) : pack.price.toFixed(2)}
                        {_t.billing.perYear()}
                    </p>
                </div>
            </div>
            <div className={'mt-4'}>
                <Button
                    onClick={() => {
                        onBuy(pack.id);
                    }}
                    busy={isLoading}
                    look="primary"
                    className={addClasses('w-full')}
                >
                    {_t.billing.buyBtn()}
                </Button>
            </div>
            {activePack && (
                <p className="text-sm mt-2">
                    {pack.priority > activePack.priority
                        ? _t.billing.upgrade()
                        : pack.priority < activePack.priority
                        ? _t.billing.downgrade()
                        : _t.billing.extend()}
                </p>
            )}
            <ol className=" flex flex-col mt-2 text-sm justify-center">
                {isUserPack ? (
                    <li key="description" className="flex gap-2 border-t first:border-none py-1 font-semibold flex">
                        <Icon icon="ei:check" width={'1.2rem'} height={'1.2rem'} />
                        <p>{_t.package.userDescription()}</p>
                    </li>
                ) : (
                    <>
                        <li key="years" className="flex gap-2 border-t first:border-none py-1 font-semibold flex">
                            <Icon icon="ei:check" width={'1.2rem'} height={'1.2rem'} />
                            <p>{_t.package.years(packageType)}</p>
                        </li>
                        <li key="users" className="flex gap-2 border-t first:border-none py-1 font-semibold flex">
                            <Icon icon="ei:check" width={'1.2rem'} height={'1.2rem'} />
                            <p>{_t.package.users(packageType)}</p>
                        </li>
                        <li key="itineraries" className="flex gap-2 border-t first:border-none py-1 font-semibold flex">
                            <Icon icon="ei:check" width={'1.2rem'} height={'1.2rem'} />
                            <p>{_t.package.itineraries(packageType)}</p>
                        </li>
                        {packageType != PackagesIDs.STANDARD && (
                            <li key="premium" className="flex gap-2 border-t first:border-none py-1 font-semibold flex">
                                <Icon icon="ei:check" width={'1.2rem'} height={'1.2rem'} />
                                <p>{_t.package.premium(packageType)}</p>
                            </li>
                        )}
                    </>
                )}
            </ol>
        </div>
    );
}
